// import { useSuspenseQuery } from '@tanstack/react-query'
import { useQuery, type UseQueryOptions, useQueryClient } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { StreamPost } from 'src/shared/schemas/stream/feed'

const getPost = async (postId: string) => {
  try {
    const response = await getRequest<StreamPost>(`/feeds/posts/lookup?post_id=${postId}`)
    if (!response) {
      throw new Error('Post not found')
    }
    return response
  } catch (error) {
    throw new Error(`Failed to fetch post | ${error}`)
  }
}

type UseGetPostOptions = Pick<UseQueryOptions<StreamPost>, 'initialData' | 'enabled'>

// Non-suspense version
export const useGetPost = (postId: string, options?: UseGetPostOptions) => {
  const queryClient = useQueryClient()

  return useQuery({
    ...queries.feeds.post(postId),
    queryFn: () => getPost(postId),
    ...options,
    placeholderData: (previousData) => {
      // Try to find the post in the timeline cache
      const timelineData = queryClient.getQueryData<{ pages: { results: StreamPost[] }[] }>(
        queries.feeds.timeline.queryKey,
      )
      if (!timelineData) return previousData

      // Look for the post in timeline pages
      const post = timelineData.pages.flatMap((page) => page.results).find((post) => post.id === postId)

      return post || previousData
    },
  })
}

// Suspense version - not in use
// export const useGetPostSuspense = (postId: string, options?: UseGetPostOptions) => {
//   return useSuspenseQuery({
//     ...queries.feeds.post(postId),
//     queryFn: () => getPost(postId),
//     ...options,
//   })
// }
